import React from 'react';
import OrderForm from 'pages/partn-brigham-and-womens-hosp-program/OrderForm';
import PdfViewer from 'pages/partn-brigham-and-womens-hosp-program/PdfViewer';
import { Wrapper } from 'styles/pages/staples-bulk-orders';

const Body = ({ state, setState }) => (
  <Wrapper>
    <OrderForm state={state} setState={setState} />
    <PdfViewer state={state} />
  </Wrapper>
);

export default Body;
